.navbar {
    background-color: var(--dib-brand-base);
    color: white;
    transition: width var(--transition-duration-snappy) ease-out;
    overflow: hidden;
    padding: 0;
}

.navbar[data-expanded="false"] {
    align-items: center;
}

.topSection {
    width: 100%;
    /* background-color: green; */
}

.bottomSection {
    margin-top: auto;
    /* background-color: blue; */
}

.logoNav {
    width: 100%;
    height: 34px;
    align-items: center;
}

/* Expanded: normal padding */
.navbar[data-expanded="true"] .logoNav {
    padding-left: calc(var(--mantine-spacing-xs) - 2px);
    padding-right: var(--mantine-spacing-xs);
}

/* Collapsed: no padding, let justify-content: center handle centering */
.navbar[data-expanded="false"] .logoNav {
    padding-left: 0;
    padding-right: 0;
    justify-content: center;
}

.link {
    text-decoration: none;
    color: inherit;
    display: block;
}

.navbarItem {
    cursor: pointer;
    color: var(--mantine-color-white);
    border-radius: var(--mantine-radius-md);
    padding-left: var(--mantine-spacing-xs);
    padding-right: var(--mantine-spacing-xs);
    transition: background-color 0.15s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
}
